import { CSSEditorWarning } from 'components/Editors/components/Editor.style';
import { JRCIcon } from 'components/JRCIcon/JRCIcon';
import React from 'react';

import { useIntl } from 'react-intl';
import { useTheme } from 'styled-components';

export const WidgetMissingToken = () => {
    const intl = useIntl();
    const theme = useTheme();

    return (
        <CSSEditorWarning>
            <JRCIcon name="icon-warning" color={theme.color.orange} />
            {intl.formatMessage({ id: 'GLOBAL_Provide_Missing_Token' })}
        </CSSEditorWarning>
    );
};
